import React, { lazy, Suspense } from 'react';
import type { DailyTimeReportButtonsProps } from './DailyTimeReportButtons';
const LazyDailyTimeReportButtons = lazy(async () => await import ('./DailyTimeReportButtons'));

const DailyTimeReportButtons = (props: DailyTimeReportButtonsProps) => (
  <Suspense fallback={null}>
    <LazyDailyTimeReportButtons {...props} />
  </Suspense>
);

export default DailyTimeReportButtons;
